// app/studente/classi.js

(function () {
    'use strict';
    var controllerId = 'classe';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$filter', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', classe]);

    function classe($rootScope, common, bDialog, $routeParams, $filter, $uibModal, datacontext, sectionMenu, filterFilter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Classi';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER');
        //vm.super = $rootScope.isAuthorized('SUPER');

        vm.objName = 'Classe'; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = vm.readOnly;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Anno', 'Classe'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[1];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Gestione Attach
        vm.fAttach = {};
        vm.filterAttach = '';
        vm.setfAttach = setfAttach;
        vm.list.attach = [];
        vm.getListAttach = getListAttach;
        vm.tSourceCode_def = 'CLS';
        vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;

        //Elenchi dettaglio        
        vm.list.incarichi = [];
        vm.list.studenti = [];

        vm.getRecord = getRecord;        
        vm.getListIncarichi = getListIncarichi;
        vm.getListStudenti = getListStudenti;
                
        //Filtro
        vm.filter = {};
        vm.filter.classe = '';        
        vm.filter.corsoId = 0;

        //filter per Anno: default l'anno corrente o per anno impostato gi� in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.filter.anno = vm.fAnno;
       
        //Elenchi per filtri e finestra modale di Create                
        vm.istituti = [];
        vm.corsi = [];
        vm.societa = [];
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        
        vm.addIncarico = addIncarico;
        vm.addStudente = addStudente;
        vm.deleteIncarico = deleteIncarico;
        vm.deleteStudente = deleteStudente;
        vm.editIncarico = editIncarico;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getTSource(vm.tSourceCode_def), getTAttach(vm.tSourceCode_def)];
            common.activateController(promises, controllerId)
              .then(function () {

                  if ($routeParams.ClasseId != null) {
                      setView('detail');
                      getRecord($routeParams.ClasseId, 0);
                  }
              });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;
            if (vm.filter.anno != $rootScope.annoScolastico)
                $rootScope.annoScolastico = vm.filter.anno;
            vm.filter.classe = vm.fClasse == null ? '' : vm.fClasse;                        

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.super_classe_countAll(vm.filter.anno, vm.filter.classe)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;
            
            vm.loading = true;
            return datacontext.super_classe_getAll(vm.pageSize, vm.page, vm.filter.anno, vm.filter.classe, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;                    
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.classe_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                vm.record.Anno = $filter('annoClasse')(vm.record.Anno);
                vm.numIncarichi = data.stat_numIncarichi;

                //Azzera liste
                vm.list.incarichi = [];
                vm.list.studenti = getListStudenti(id);
                getListAttach(vm.record.Id);
                setView('detail');
            });
        }                

        function addRecord(id) {
            return datacontext.classe_get(id).then(function (data) {                
                vm.records.push(data);
                vm.countRecords++;
            });
        }        

        function deleteItem(item) {
            if (item.stat_numStudenti > 0 || item.stat_numIncarichi > 0) {
                logError('Non &egrave; possibile eliminare questa classe');
                return;
            }

            var msg = ' classe ' + item.classe;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.classe_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                    return logSuccess('Dato eliminato');
                });
            });
        }

        function updateItem() {
            return datacontext.classe_update(vm.record).then(function (data) {
                if (!data)
                    logSuccess('Dati salvati');
                else
                    logError('Impossibile salvare i dati');
            });
        }

        //List Methods
        function getListIncarichi(id) {
            if (!id) return;

            return datacontext.incarico_getAllByClasse(id).then(function (data) {                
                vm.numIncarichi = data.length;
                if (data.constructor === Array) {
                    vm.record.sumOreDocenze = 0;
                    data.forEach(function (data) {
                        vm.record.sumOreDocenze += data.Ore;
                    });
                }
                return vm.list.incarichi = data;
            });
        }

        function getListStudenti(id) {
            if (!id) return;            

            //Questo metodo serve nella schermata dettaglio classe
            //Calcola le statistiche degli allievi relativi alla classe passata (minuti svolti, minuti previsti)
            return datacontext.super_studente_getAllByClasseId(id).then(function (data) {
                return vm.list.studenti = data;
            });
        }              

        function getRisorseList() {
            return datacontext.super_risorsa_getAllList().then(function (data) {                
                return data;
            });
        }       

        //Metodi di delete object List
        function deleteIncarico(item) {            
            if (item.stat_OreLezioni > 0) {
                logError('Non &egrave; possibile eliminare un docente attivo dalla classe');
                return;
            }

            var msg = ' docente ' + item.Risorsa + ' dalla classe ' + vm.record.classe;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.incarico_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    getListIncarichi(vm.record.Id);
                });
            });
        }
        
        function deleteStudente(studente) {
            var msg = ' allievo ' + studente.Cognome + ' ' + studente.Nome + ' dalla classe ' + vm.record.classe; 
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.studente_classeDelete(studente.Id, vm.record.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');

                    var index = vm.list.studenti.indexOf(studente)
                    vm.list.studenti.splice(index, 1);
                });
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            datacontext.indirizzo_getAllList().then(function (data) {
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/classe/modal/classeAdd.html?version=43',
                    controller: 'classeAdd',
                    resolve: {
                        indirizzi: function () {
                            return data;
                        },
                        anno: function () {
                            return vm.fAnno;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (!returnItem) return logError('Errore durante la rimozione del dato');

                    logSuccess('Dato salvato con successo');
                    cerca();
                });
            });
        }

        // Studente
        function addStudente() {            
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    keyboard: false,
                    templateUrl: '/app/classe/modal/classeStudenteAdd.html?version=43',
                    controller: 'classeStudenteAdd',
                    resolve: {
                        classe: function () {
                            return vm.record;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    getListStudenti(vm.record.Id);
                    logSuccess("Dato salvato con successo");
                });            
        }

        // Incarico
        function addIncarico() {
            var risorse = getRisorseList();            
            var record = { Id: vm.record.Id, Name: vm.record.classe }

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incarico/modal/incaricoAddEdit.html?version=43',
                controller: 'incaricoAddEdit',
                resolve: {
                    incarico: function () {
                        return null;
                    },
                    classi: function () {
                        return [record];        //Carica Array con la sola classe visualizzata 
                    },
                    classeId: function () {
                        return vm.record.Id;    //ClasseId impostata con record visualizzato
                    },
                    risorse: function () {
                        return risorse;   
                    },
                    risorsaId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato');
                                
                logSuccess('Dato salvato con successo');
                getListIncarichi(vm.record.Id);
            });
        }

        function editIncarico(incarico) {
            var risorse = getRisorseList();
            var record = { Id: vm.record.Id, Name: vm.record.classe };

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/incarico/modal/incaricoAddEdit.html?version=43',
                controller: 'incaricoAddEdit',
                resolve: {
                    incarico: function() {
                        return incarico;
                    },
                    classi: function () {
                        return [record];        //Carica Array con la sola classe visualizzata 
                    },
                    classeId: function () {
                        return vm.record.Id;    //ClasseId impostata con record visualizzato
                    },
                    risorse: function () {
                        return risorse;
                    },
                    risorsaId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {                
                if (!returnItem) {
                    logSuccess('Dato salvato con successo');
                    getListIncarichi(vm.record.Id);
                }
                else 
                    return logError('Errore durante il salvataggio del dato');
            });
        }

        //Gestione Attach
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }

        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAll(0, 0, vm.tSourceCode_def, 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                return vm.list.attach = data;
            });
        }

        function addAttach(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name }
            var recSource = { Id: vm.record.Id, Name: vm.record.Cognome + ' ' + vm.record.Nome }

            var modalInstance = $uibModal.open({
                templateUrl: '/app/attach/modal/attachAdd.html?version=43',
                controller: 'attachAdd',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: formato allegato non corretto! ');
                if (returnItem == "400") return logError('Errore registrazione dati [' + returnItem + ']');

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);
                //vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function deleteAttach(item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');

                    var index = vm.list.attach.indexOf(item)
                    vm.list.attach.splice(index, 1);
                    //vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
                });
            });
        }
    }
})();
